import useAbTestInit from './hooks/use-ab-test-init';
import useAbTest from './hooks/use-ab-test';
import Component from './components';
import Context from './context';
import GlobalProvider from './config/ab-test-global-provider';

const ABTesting = { Component, Context, GlobalProvider };

export { ABTesting, useAbTestInit, useAbTest };
